import React, { Component } from "react";
import { connect } from "react-redux";
import { AreYouAgreeModal, BreadCumb, DataTables, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from 'moment';
import ApiClient from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
const TODAY = moment(new Date()).format('YYYY-MM-DD');

const apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Estatus", value: true },
    { title: "Num.Doc", value: true },
    { title: "Empleado", value: true },
    { title: "Nombre", value: true },
    { title: "Folio", value: true },
    { title: "Fecha", value: true },
    { title: "Total", value: true }]

class timbraNominasView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),

        }
    }

    async componentDidMount() {
        this.SearchDocuments()
    }

    SearchDocuments = async (newDate) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        const data = {
            dateInit: newDate?.dateInit ?? TODAY,
            dateFinal: newDate?.dateFinal ?? TODAY,
            docNumSearch: newDate?.docNumSearch ?? '--',
        };

        enableSpinner(true);
        const resData = await apiClient.GetListNominas(data);
        enableSpinner(false);

        if (resData.status !== 1) {
            showAlert({ type: 'warning', timeOut: 5000, message: `${resData.message ?? ''}` });
        }

        if (resData.data.length === 0) {
            showAlert({ type: 'info', timeOut: 5000, message: `No se encontró información` });
        }

        this.setState({
            data: resData.data ?? []
        })
    }

    render() {
        const { headers, data, _user } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'NOMINAS'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <label className="text-muted">
                            &nbsp;NOMINAS
                        </label>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"timbNominas"}
                        data={data}
                        search={this.SearchDocuments}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(timbraNominasView);